var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-container"},[_vm._l((_vm.data),function(item,index){return _c('div',{key:index},[_c(item.type,{tag:"component",attrs:{"data":item}})],1)}),_c('div',{staticStyle:{"height":"50px"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }